import { ParentAccountDto } from '@/models/suba/ParentAccountDTO.model';

export const getParentAccountName = (
  parentAccount?: ParentAccountDto,
  plan?: {
    name: string;
  }
) => {
  return (
    plan?.name || parentAccount?.plan?.name || parentAccount?.accountName || ''
  );
};
